/**
 * CameraArrow Component
 * 
 * Animated arrow that points to the camera button in the control tray.
 * Guides users to click the camera button for live streaming.
 */

import React from 'react';
import './camera-arrow.scss';

interface CameraArrowProps {
  language: 'ar' | 'en' | 'ur';
}

const texts = {
  ar: {
    clickHere: 'اضغط هنا',
    openCamera: 'لفتح الكاميرا'
  },
  en: {
    clickHere: 'Click here',
    openCamera: 'to open camera'
  },
  ur: {
    clickHere: 'یہاں کلک کریں',
    openCamera: 'کیمرا کھولنے کے لیے'
  }
};

export default function CameraArrow({ language }: CameraArrowProps) {
  const t = texts[language];
  const isRTL = language === 'ar' || language === 'ur';

  return (
    <div className={`camera-arrow-container ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="arrow-content">
        <p className="arrow-text">
          <strong>{t.clickHere}</strong>
          <br />
          {t.openCamera}
        </p>
        
        {/* Animated arrow SVG pointing down */}
        <svg 
          className="arrow-svg" 
          width="60" 
          height="60" 
          viewBox="0 0 60 60"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#2563eb', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#1d4ed8', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          
          {/* Arrow body */}
          <path
            d="M30 10 L30 40"
            stroke="url(#arrowGradient)"
            strokeWidth="4"
            strokeLinecap="round"
            fill="none"
          />
          
          {/* Arrow head */}
          <path
            d="M30 40 L20 30 M30 40 L40 30"
            stroke="url(#arrowGradient)"
            strokeWidth="4"
            strokeLinecap="round"
            fill="none"
          />
        </svg>

        {/* Camera icon indicator */}
        <div className="camera-icon-hint">
          <span className="material-symbols-outlined">videocam</span>
        </div>
      </div>
    </div>
  );
}
